import { IOptions } from "components/DropdownSelect";

export const statusOptions: IOptions[] = [
  { value: 0, label: "Pendente" },
  { value: 1, label: "Finalizado" },
];

// TODO(DAD-2728): confirmar os valores reais de tipo de pagamento com o backend.
export const tipoPagamentoOptions: IOptions[] = [
  { value: "CPF/CNPJ", label: "CPF/CNPJ" },
  { value: "Renavam", label: "Renavam" },
];
